<template>
  <div>
    <h4>{{ $t('changePassword')}}</h4>
    <div class="box-block">
      <ValidationObserver ref="form" vid="form" v-slot="{ invalid }">
        <form class="mb-3">
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="oldPassword"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="old"
                    >{{ $t('form.oldPassword')}}<sup class="text-danger">*</sup></label
                  >
                  <input
                    type="password"
                    v-model="oldPassword"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="old"
                    placeholder=""
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="password"
                  rules="required|min:6"
                  v-slot="{ errors }"
                  vid="password"
                  mode="lazy"
                >
                  <label for="new"
                    >{{ $t('form.newPassword')}}<sup class="text-danger">*</sup></label
                  >
                  <input
                    type="password"
                    v-model="newPassword"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="new"
                    placeholder=""
                  />
                  <span class="text-muted small">{{ $t('form.passwordRule')}}</span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="confirmation"
                  rules="confirmed:password"
                  v-slot="{ errors }"
                  vid="confirmation"
                  mode="lazy"
                >
                  <label for="new2"
                    >{{ $t('form.confirmationPassword')}}<sup class="text-danger"
                      >*</sup
                    ></label
                  >
                  <input
                    type="password"
                    v-model="confirmed"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    id="new2"
                    placeholder=""
                  />
                  <span class="text-danger small">{{errors[0]}}</span>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-3">
            <div></div>
            <div v-if="monitor.visible" :class="monitor.type">
                {{ monitor.message }}
              </div>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="invalid"
              @click.stop.prevent="update"
            >
              {{ $t('buttons.save')}}
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'changing-password',
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      confirmed: null,
      matchPassword: true,
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['cart']),
  },
  methods: {
    update() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return
        }
        let params = {}
        if (this.oldPassword) {
          params.old_password = this.oldPassword
        }
        if (this.newPassword) {
          params.new_password = this.newPassword
        }
        if (this.confirmed) {
          params.confirm_password = this.confirmed
        }
        this.$store.dispatch('changingPassword', params)
        .then(() => {
          this.monitor.type = 'text-success'
          this.monitor.message = this.$t('updatePasswordSuccessfully')
          this.monitor.visible = true
          setTimeout(() => {
            this.$refs.form.reset()
          }, 3000)
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 401) {
              this.monitor.type = 'text-danger'
              this.monitor.visible = true
              this.monitor.message = this.$t('errors.checkOldPassword')
            } else if (error.response.status == 406) {
              this.monitor.type = 'text-danger'
              this.monitor.visible = true
              this.monitor.message = this.$t('errors.mustBeDifferent')
            } 
             else if (error.response.status == 400) {
              this.monitor.type = 'text-danger'
              this.monitor.visible = true
              this.monitor.message = this.$t('errors.passwordMatch')
            } 
            else {
              this.monitor.message = this.$t('errors.serverError');
            }
            setTimeout(() => {
              this.monitorHide()
            }, 4000)
          }
        })
        this.$nextTick(() => {
          this.$refs.form.reset()
        })
      })
    },
    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style></style>
